import { authenticatedCopilotServer } from "@/core/api";
import { LexZapMessagePage } from "./types";
import { Case } from "@/hooks/lexZap/types";
import { LexZapChannel } from "./types";
import { LexZapUser } from "@/hooks/lexZap/types";
import { ActivityArea, Department } from "@/hooks/company/types";
import { UpdateLexZapChannelParams, UpdateLexZapCompanyParams } from "@/hooks/useApi/types";
import { Ticket } from "@/hooks/lexZap/types";

export const LexZapService = {
  getMe: async () => {
    const response = await authenticatedCopilotServer.get<LexZapUser>(`whatsapp-assistant/users/me`);
    return response.data;
  },
  updateMe: async (data: { notificationNumber: string; department: Department; activityAreas?: ActivityArea[] }) => {
    await authenticatedCopilotServer.post<LexZapUser>(`whatsapp-assistant/users/me`, data);
  },
  getTickets: async (params?: { status?: "ACTIVE" | "CLOSED" }) => {
    const response = await authenticatedCopilotServer.get<Ticket[]>(`/whatsapp-assistant/tickets`, {
      params,
    });
    return response.data;
  },
  signFileUrl: async ({ fileId }: { fileId: string }) => {
    const response = await authenticatedCopilotServer.get<{ signedUrl: string }>(
      `/whatsapp-assistant/files/${fileId}/signUrl`
    );
    return response.data;
  },
};

export const AdminLexZapService = {
  getLexZapCases: async ({ companyId }: { companyId: string }) => {
    const response = await authenticatedCopilotServer.get<Case[]>(`/admin/cases`, {
      params: {
        companyId,
      },
    });
    return response.data;
  },
  getLexZapMessages: async ({
    companyId,
    applicantPhoneNumber,
    limit,
    pageToken,
  }: {
    companyId: string;
    applicantPhoneNumber: string;
    limit?: number;
    pageToken?: string;
  }) => {
    const response = await authenticatedCopilotServer.get<LexZapMessagePage>(`/admin/cases/chats/messages`, {
      params: { companyId, applicantPhoneNumber, limit, pageToken },
    });
    return response.data;
  },
  updateLexZapCompany: async ({ companyId, email, updates }: UpdateLexZapCompanyParams) => {
    await authenticatedCopilotServer.put(`whatsapp-assistant/companies/${companyId}`, {
      email,
      ...updates,
    });
  },
  getLexZapChannels: async () => {
    const response = await authenticatedCopilotServer.get<LexZapChannel[]>("whatsapp-assistant/channels");
    return response.data;
  },
  createLexZapChannel: async ({ channelId }: { channelId: string }) => {
    await authenticatedCopilotServer.post("whatsapp-assistant/channels", {
      channelId,
    });
  },
  updateLexZapChannel: async ({ channelId, updates }: UpdateLexZapChannelParams) => {
    await authenticatedCopilotServer.patch(`whatsapp-assistant/channels/${channelId}`, {
      ...updates,
    });
  },
  deleteLexZapChannel: async ({ channelId }: { channelId: string }) => {
    await authenticatedCopilotServer.delete(`whatsapp-assistant/channels/${channelId}`);
  },
};
